<div class="mat-dialog-containers">
    <mat-icon class="close" (click)="close()">close</mat-icon>
    <div mat-dialog-title class="mat-dialog-title">
        <img style="width: 16rem;" src="assets/imagenes/logo-coomeva.webp">
    </div>
    <div mat-dialog-content class="mat-dialog-content">
        <span><b>Detalle de Anexos</b></span>        
        <div class="dialog-data-container">
            <div class="dialog-data-card">
                <div *ngFor="let item of dataDetail">
                    <span class="dialog-data-card-header">Plan: </span><span class="dialog-data-card-info">{{ item.codigoplan }}</span>
                    <br>
                    <span class="dialog-data-card-header">Vigencia: </span><span class="dialog-data-card-info">{{ item.vigencia }}</span>
                </div>
            </div>       
        </div>
    </div> 
</div>
